import { projects } from "./projects";

export { projects };

export const Bio = {
  name: "Vivek Carpenter",
  roles: [
    "MERN Stack Developer",
    "React.js & Node.js Developer",
    "Full Stack Engineer",
    "Frontend Specialist",
    "REST API & Cloud Architect"
  ],
  title: "MERN Stack Developer",
  experienceYears: "1.6+",
  location: "Indore, Madhya Pradesh, India",
  phone: "+91 7000673729",
  email: "vivekcarpenter4526@gmail.com",
  summary:
    "MERN Stack Developer with 1.6+ year of experience building scalable web applications using React.js, Node.js, Express.js, and MongoDB. Experienced in REST APIs, Redux Toolkit, RTK Query, JWT, RBAC, AI API integration, Docker, AWS, and VPS deployment. Strong focus on clean architecture, performance optimization, debugging, and end-to-end development.",
  description:
    "MERN Stack Developer based in Indore, India. I specialize in developing production-ready web platforms with React.js, Node.js, Express, and MongoDB — focusing on clean architecture, secure authentication, and high performance.",
  github: "https://github.com/vivekcarpenter",
  resume: "https://drive.google.com/file/d/1mbzeafoBBHOP3jVU8TLciiWU0PtKy9WY/view?usp=sharing",
 
  linkedin: "https://linkedin.com/in/vivek-carpenter-84845a242",
  insta: "https://www.instagram.com/vivek_carpenter_/",
  facebook: "https://hi-in.facebook.com/viveksuthar.nmh/",
  availability: "Open to Full-Time MERN & Frontend Roles"
};

export const skills = [
  {
    title: "Frontend Development",
    category: "frontend",
    skills: [
      {
        name: "React.js",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg"
      },
      {
        name: "JavaScript (ES6+)",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png"
      },
      {
        name: "TypeScript",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
      },
      {
        name: "Next.js",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg"
      },
      {
        name: "Redux Toolkit",
        image: "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg"
      },
      {
        name: "RTK Query",
        image: "https://raw.githubusercontent.com/reduxjs/redux-toolkit/master/docs/static/img/redux.svg"
      },
      {
        name: "Tailwind CSS",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-original.svg"
      },
      {
        name: "HTML5 & CSS3",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png"
      },
      {
        name: "Three.js",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/threejs/threejs-original.svg"
      }
    ]
  },
  {
    title: "Backend & Database",
    category: "backend",
    skills: [
      {
        name: "Node.js",
        image: "https://nodejs.org/static/images/logo.svg"
      },
      {
        name: "Express.js",
        image: "https://www.technoscore.com/img/expressjs.png"
      },
      {
        name: "REST APIs",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/fastapi/fastapi-original.svg"
      },
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg"
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg"
      },
      {
        name: "JWT & RBAC",
        image: "https://jwt.io/img/pic_logo.svg"
      },
      {
        name: "Redis",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original.svg"
      },
      {
        name: "MVC Architecture",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg"
      }
    ]
  },
  {
    title: "Cloud & DevOps",
    category: "tools",
    skills: [
      {
        name: "Docker",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg"
      },
      {
        name: "AWS (S3, Lambda, CloudFront)",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"
      },
      {
        name: "Hostinger VPS",
        image: "https://www.vectorlogo.zone/logos/linux/linux-icon.svg"
      },
      {
        name: "Git & GitHub",
        image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
      },
      {
        name: "AI API Integration",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
      },
      {
        name: "Postman",
        image: "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667"
      }
    ]
  }
];

export const experiences = [
  {
    id: 1,
    role: "MERN Stack Developer",
    company: "Krishaa Soft IT Solutions",
    location: "Indore, Madhya Pradesh",
    date: "Jan 2026 – Present",
    desc: "Leading full-stack MERN development across veterinary healthcare software and e-commerce web applications with secure REST APIs, role-based access control, and VPS deployments.",
    projects: [
      {
        title: "Pet Medical Software",
        bullets: [
          "Developed a full-stack veterinary management platform covering patient records, diagnosis, prescriptions, reports, dynamic forms, file uploads, and analytics.",
          "Built secure REST APIs with JWT authentication and RBAC, and implemented Redux Toolkit / RTK Query for state management and API caching.",
          "Integrated AI-powered functionality, PDF/report generation, dashboards, and responsive frontend workflows."
        ]
      },
      {
        title: "Ariqua — E-Commerce Platform",
        bullets: [
          "Developed product, category, cart, authentication, order, checkout, and role-based admin modules.",
          "Built REST APIs and integrated Redux Toolkit / RTK Query for efficient data fetching, caching, and frontend-backend synchronization.",
          "Implemented image/file uploads, cloud storage, validation, third-party integrations, Docker workflows, and production deployment on Hostinger VPS."
        ]
      }
    ],
    skills: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redux Toolkit",
      "RTK Query",
      "JWT & RBAC",
      "Docker",
      "Hostinger VPS",
      "AI API Integration"
    ]
  },
  {
    id: 2,
    role: "Jr. Full Stack Developer",
    company: "WenBear Technologies Pvt. Ltd.",
    location: "Indore, Madhya Pradesh",
    date: "Jun 2025 – Jan 2026",
    desc: "Engineered scalable full-stack features using React.js, Node.js, Express.js, and MongoDB with clean reusable components.",
    bullets: [
      "Developed full-stack applications using React.js, Node.js, Express.js, and MongoDB.",
      "Built reusable React components, REST APIs, form validation, file uploads, authentication flows, and dynamic database-driven features.",
      "Optimized application performance and collaborated with developers and designers to deliver production-ready features."
    ],
    skills: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "REST APIs",
      "Form Validation",
      "Auth Flows"
    ]
  },
  {
    id: 3,
    role: "React Developer Intern",
    company: "Precious Info System Pvt. Ltd.",
    location: "Indore, Madhya Pradesh",
    date: "Jan 2025 – Apr 2025",
    desc: "Built responsive frontend user interfaces with React.js and Tailwind CSS, integrating RESTful backend endpoints.",
    bullets: [
      "Developed responsive React.js interfaces using React.js and Tailwind CSS and integrated REST APIs.",
      "Implemented dynamic data rendering, reusable components, testing, debugging, and UI improvements."
    ],
    skills: [
      "React.js",
      "Tailwind CSS",
      "JavaScript (ES6+)",
      "REST APIs",
      "Debugging"
    ]
  }
];

export const education = [
  {
    id: 1,
    school: "Medicaps University, Indore",
    degree: "Master of Computer Applications (MCA)",
    date: "2022 – 2024",
    desc: "Post-graduate degree in Computer Applications focusing on advanced software engineering, data structures, full-stack web technologies, and database architecture."
  },
  {
    id: 2,
    school: "Vikram University, Ujjain",
    degree: "Bachelor of Science in Computer Science (B.Sc)",
    date: "2019 – 2022",
    desc: "Foundational undergraduate degree in Computer Science covering core programming fundamentals, operating systems, algorithm design, and software development methodologies."
  }
];

export const TimeLineData = [
  { year: "2019 – 2022", text: "Completed B.Sc in Computer Science at Vikram University, Ujjain" },
  { year: "2022 – 2024", text: "Earned Master of Computer Applications (MCA) at Medicaps University, Indore" },
  { year: "Jan – Apr 2025", text: "React Developer Intern at Precious Info System Pvt. Ltd., Indore" },
  { year: "Jun 2025 – Jan 2026", text: "Jr. Full Stack Developer at WenBear Technologies Pvt. Ltd., Indore" },
  { year: "Jan 2026 – Present", text: "MERN Stack Developer at Krishaa Soft IT Solutions, Indore" }
];
